// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { ProjectModel } from '@project/model/project.model';
import { Mesh } from 'three';
import { LoadConnectionTextureProcessor } from '../processor/load-connection-texture.processor';
import { ConfiguratorScene } from '../scene/configurator-scene';
import { ArticleContainer } from './article-container';
import { Connection } from './connection';
import { ContainerService } from './container.service';

@Injectable({ providedIn: 'root' })
export class ConnectionFactory {
  constructor(
    private _loadConnectionTextureProcessor: LoadConnectionTextureProcessor,
    private _configuratorScene: ConfiguratorScene,
    private _projectModel: ProjectModel,
    private _componentUtils: ContainerService
  ) {}

  public getNewInstance(articleContainer: ArticleContainer, mesh: Mesh, type: string = null): Connection {
    const connection = new Connection(
      this._loadConnectionTextureProcessor,
      this._configuratorScene,
      this._projectModel,
      articleContainer,
      () => this._componentUtils.updateConnectionAvailability(connection),
      mesh,
      type
    );
    return connection;
  }
}
